module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-ExtraLightItalic.69cb47a.woff2";